import React from 'react'
import Link from 'gatsby-link'
import Lightbox from 'react-images';
import Gallery from '../../components/Gallery/gallery';
const tstPage = ({ children, location }) => {
    const mockImg = require("../../assets/img/projects/tst/frame-mock.png");
    const screenshots = [{ src: require("../../assets/img/projects/tst/ss.png") }, { src: require("../../assets/img/projects/tst/ss2.png") }, { src: require("../../assets/img/projects/tst/ss3.png") }]
    return (
        <div className="portofolio-project-wrapper ">
            <div className="portofolio-project tst ">
                <h1> Tvshowtrack</h1>
                <div className="project-subtitle">
                    <div className="project-status"><span>Status: </span> Completed</div>
                    <div className="project-link"><a href="http://www.tvshowtrack.com" target="_blank">View Application</a></div>
                </div>
                <img src={mockImg} alt="tst Screenshots" />
                <div className="project-section project-intro">
                    <h2>Introduction</h2>
                    <p>
                        A basic TV series tracker. Allows users to see various details about their favourite TV Shows.
                    </p>
                    <div className="project-tags">
                        <span>#AngularJS</span>
                        <span>#Flask</span>
                        <span>#Heroku</span>
                    </div>
                </div>
                <div className="project-section project-features">
                    <h2>Achievements</h2>
                    <ul>
                        <li><i className="fa fa-check"></i>Server-side rendering with Angular Universal</li>
                        <li><i className="fa fa-check"></i>Using the <a href="https://www.tvmaze.com/api" target="_blank">TV Maze API</a></li>
                        <li><i className="fa fa-check"></i>Using cron functions to periodically fetch Tv Series data</li>
                        <li><i className="fa fa-check"></i>Deployed to Digital Ocean using a custom domain </li>
                    </ul>
                </div>
                <div className="project-section project-screenshots">
                    <h2>Screenshots</h2>
                    <Gallery images={screenshots} />
                </div>
            </div>
        </div>
    )
};

export default tstPage;



// WEBPACK FOOTER //
// ./src/pages/portofolio/tst.js